import classNames from 'classnames'
import { type MouseEventHandler } from 'react'
import { Typography } from 'shared/ui/Typography'
import { IconButton } from 'shared/ui/IconButton'
import type { IDropdownItem } from 'shared/ui/Dropdown'
import styles from './styles.module.scss'

export interface IChipProps {
  label: string
  item?: IDropdownItem
  clickable?: boolean
  iconType?: 'button' | 'div'
  onDelete?: MouseEventHandler<HTMLButtonElement | HTMLDivElement>
  variant?: 'primary' | 'secondary'
}

export const Chip = ({
  label,
  clickable = false,
  iconType = 'button',
  onDelete,
  item,
  variant = 'primary',
}: IChipProps) => {
  return (
    <div
      className={classNames(
        styles.wrap,
        styles[variant],
        { [styles.clickable]: clickable, [styles.withoutDelete]: !onDelete },
        item?.className
      )}
    >
      <Typography
        ariaLabel='ChipLabel'
        variant='body-md-regular'
        color='var(--content-primary-primary)'
        ellipsis
      >
        {label}
      </Typography>
      {onDelete && (
        <IconButton
          color='transparent'
          size='mini'
          tag={iconType}
          icon='close'
          variant='icon'
          fontSize={16}
          onClick={onDelete}
          ariaLabel='ChipClose'
          className={styles.icon}
        />
      )}
    </div>
  )
}
